app.directive(
  'taille', function () {  // directive de app, pour trouver au chargement
    // (on_load la taille reelle de l'image)
    return {
      link: function (scope, element, attrs) {
        element.bind('load', function (e) {
          // success, "onload" catched
          // now we can do specific stuff:
          document.getElementById('px').innerHTML = element[0].naturalWidth;
          document.getElementById('py').innerHTML = element[0].naturalHeight;
        });
      }
    }
  });

app.controller(
  'copCtrl',
  function (
    $rootScope, $scope, services, $location, ngTableParams, $filter,
    fctService, ServiceQcm, toastr, $q) {
    var _DEBUG = 0;
    $scope.url_ = $rootScope.url_;

    var val = 1;
    // $scope.choixPAGE = 0  : l'image de la copie (avec cases à cocher)
    // $scope.choixPAGE = 1  : le tableau normal
    // $scope.choixPAGE = 4  : liste des copies anonymes (avec images)
    // $scope.choixPAGE = 3  : ???
    // $scope.choixPAGE = 4  : ???
    // $scope.choixPAGE = 5  : doublon
    // $scope.choixPAGE = 6  : analyse
    // $scope.choixPAGE = 10 : analyse
    // $scope.choixPAGE = 12 : remord

    $scope.choixPAGE = 1;

    /************************************************************************************************/
    $scope.init = function () {
      $rootScope.menuSelectionne = 5;
      $scope.choixPAGE = 1;  // liste des copie
      $scope.afficheEtudiant = 0;
      $scope.indiceCopie = 0;
      $scope.data = [];

      $scope.page_a_ete_change = 0;  // new
      //$scope.affichePage=0;//new

      $scope.rd = Date.now();

      if (typeof ($rootScope.qcmSelectionne.id) == 'undefined') {
        $scope.choixQCM = -1;
        $rootScope.menuSelectionne = 1;
        $location.path('/0lst');
      } else {
        $scope.choixQCM = $rootScope.qcmSelectionne.id;
        $scope.loader = 1;
        $scope.modif = 0;
      }

      var i = 1;  // new
      $scope.option2 = new Array;
      for (i = 1; i <= $scope.qcmSelectionne.multi_nbpage; i++) {
        $scope.option2.push({ 'v': i, 'label': i.toString() });
      }
      $scope.nbNumero = val.nbNumero - 1;


      //$scope.rechargerTout();
      //$scope.majListeCopie();
      $scope.loader = 1;
      new ServiceQcm.chargement($rootScope.qcmSelectionne)
        .then(function (data) {
          new ServiceQcm.calculNotes($rootScope.qcmSelectionne)
            .then(function (data) {
              $scope.qcmSelectionne = $rootScope.qcmSelectionne;
              ////$scope.data2 = $scope.data;

              var resCopie = $rootScope.qcmSelectionne.listeCopie;
              var nbcopies = $rootScope.qcmSelectionne.listeCopie.length;

              // $scope.tableDesCopies.reload()
              $scope.modif = 0;
              $scope.listeCopie = $rootScope.qcmSelectionne.listeCopie;
              $scope.data = $scope.listeCopie;

              /****************************************/
              var nb_max = Math.max(
                $rootScope.qcmSelectionne.listeCopie.length, 100);
              $scope.tableDesCopies = new ngTableParams(
                {
                  page: 1,    // show first page
                  count: 10,  // count per page
                  // filter: { id: '', nom:'', prenom:'', page:'',
                  // fichier:'', note:''},           // count per page
                  sorting: { id: 'asc' }
                },
                {
                  total: $scope.listeCopie.length,  // length of data
                  counts: [10, 25, nb_max],
                  getData: function ($defer, params) {
                    $scope.data = params.filter() ?
                      $filter('filter')(
                        $scope.listeCopie, params.filter()) :
                      $scope.listeCopie;
                    $scope.data = params.sorting() ?
                      $filter('orderBy')(
                        $scope.data, params.orderBy()) :
                      $scope.listeCopie;
                    $scope.data = $scope.data.slice(
                      (params.page() - 1) * params.count(),
                      params.page() * params.count());

                    $defer.resolve($scope.data);
                  }
                });
              /****************************************/
              $scope.doute = 0;
              for (var i = 0;
                i < $rootScope.qcmSelectionne.listeCopie.length; i++) {
                if ($rootScope.qcmSelectionne.listeCopie[i].doute > 0) {
                  $scope.doute++;
                }
              }

              $scope.loader = 0;
            })
        })

      if ($rootScope.qcmSelectionne.listeCopie.length == 0) {
        toastr.info(
          '___Retourner dans le menu 4, pour envoyer les fichiers___');
      }
    };



    /************************************************************************************************/
    $scope.rechargerTout = function () {
      $scope.loader = 1;
      new ServiceQcm.chargement($rootScope.qcmSelectionne)
        .then(function (data) {
          new ServiceQcm.calculNotes($rootScope.qcmSelectionne)
            .then(function (data) {
              $scope.qcmSelectionne = $rootScope.qcmSelectionne;
              $scope.listeCopie =
                $rootScope.qcmSelectionne.listeCopie;  // new

              resCopie = $rootScope.qcmSelectionne.listeCopie;
              nbcopies = $rootScope.qcmSelectionne.listeCopie.length;

              $scope.doute = 0;
              for (var i = 0; i < $scope.qcmSelectionne.listeCopie.length;
                i++) {
                if ($scope.qcmSelectionne.listeCopie[i].doute > 0) {
                  $scope.doute++;
                }
              }

              $scope.tableDesCopies.reload();
              $scope.loader = 0;
              $scope.modif = 0;
            })
        })
    };

    /************************************************************************************************/
    $scope.cancel = function () {  // revenir à la liste des qcm
      $location.path('/0lst');
    };
    /******************************************************************************************************/
    $scope.changePage = function (
      copiedata,
      nbNumero) {  // revenir à la liste des qcm - new
      if (typeof (nbNumero) === 'undefined') return;
      $scope.page_a_ete_change = 1;
      // 1. changer la page dans bdd
      a = new services.modifPage(copiedata.id, nbNumero.v)
        .then(function (data) {
          $scope.qcmSelectionne.ListePBpage.splice(
            $scope.qcmSelectionne.ListePBpage.indexOf(copiedata), 1);

          // si on est sur une copie : une affiche toute la page
          if ($scope.choixPAGE == 0 || $scope.choixPAGE == 12) {
            alert('___rechargement nécessaire___');
            $scope.init();
          }
        });
      // 3. refaire les calculs : quand on recharge la page uniquement...
    };
    /************************************************************************************************/
    $scope.retour = function () {  // new
      if ($scope.page_a_ete_change == 0) {
        $scope.choixPAGE = 1;
      } else {
        $scope.init();
      }
    };

    /******************************************************************************************************/
    $scope.associeNew = function (copie, etud) {
      if (typeof (etud) === 'undefined') return;

      if (typeof (etud.numero) == 'undefined' || etud.numero == '') {
        // demande : pas de numéro -> message & affectation incrémental"
        var nouveau_numero = 1;
        for (i = 0; i < $rootScope.qcmSelectionne.listeEtudiant.length;
          i++) {  // new
          if ($rootScope.qcmSelectionne.listeEtudiant[i].numero >
            nouveau_numero)
            nouveau_numero =
              $rootScope.qcmSelectionne.listeEtudiant[i].numero + 1;
        }
        toastr.error(
          '___Le numéro est donné par défaut___ : ' + nouveau_numero);
        etud.numero = nouveau_numero;
      }
      if ((parseFloat(etud.numero) == parseInt(etud.numero)) &&
        !isNaN(etud.numero)) {
        ;  // ok
      } else {
        toastr.error('___Entrer un numéro d\'étudiant valide___');
        return;
      }

      etud.id = $rootScope.qcmSelectionne.id;
      etud.idcopie = copie.id;
      // créer l'étudiant
      // lui associer la copie
      // maj les tableaux

      // alert('bouton :'+etud.nom)
      $scope.modif = 1;

      services
        .ajouterETUDIANT(etud, 'scan')

        .then(function (data) {
          etud.idetudiant = data.data.idetudiant;
          a = services
            .listeCopieEtudiant(
              $rootScope.qcmSelectionne.id, copie.id,
              etud.idetudiant, etud.numero)
            .then(function (data) {
              $scope.rechargerTout();
              copie.nom = etud.nom;
              copie.prenom = etud.prenom;
              copie.numero = etud.numero;
              copie.numEtudiant = etud.numero;
            });
        })
        .catch(function (response) { })
        .finally(function (data) {
          toastr.info('___Etudiant ajouté et associé à la copie___');
          // alert("2:"+data)
        })

      // $scope.ListeCopieInconnues.splice($scope.ListeCopieInconnues.indexOf(copie),
      // 1);
    };

    /************************************************************************************************/
    $scope.associeChoix = function (copie, etud) {
      if (typeof (etud) === 'undefined') return;
      $scope.modif = 1;

      // associer l'étudiant à la copie dans la BDD
      a = services
        .listeCopieEtudiant(
          $rootScope.qcmSelectionne.id, copie.id, etud.idetudiant,
          etud.numero)
        .then(function (data) {
          $scope.rechargerTout();

          $scope.qcmSelectionne = $rootScope.qcmSelectionne;
          copie.nom = etud.nom;
          copie.prenom = etud.prenom;
          copie.numero = etud.numero;
          copie.numEtudiant = etud.numero;

          toastr.info('___Etudiant associé à la copie___');
        });
    };


    /************************************************************************************************/
    $scope.filtre = function (val) {
      var deferred = $q.defer();


      try {
        // alert("on entre , Copie="+typeof(Copie.id)+" et ="+ Copie.id);
        if (typeof (val) == 'undefined') {
          return;
        }


        if ($scope.modif == 1) {
          $scope.rechargerTout();
          $scope.modif = 0;
        }

        $scope.qcmSelectionne = $rootScope.qcmSelectionne

        if (val ==
          4) {  // afficher les copies inconnues (sans étudiant associé)
          $scope.etudiant1 =
            { 'numero': '', 'nom': '', 'prenom': '', 'idcopie': 0 };
          $scope.choixPAGE = 4;
        }
        else if (val == 5) {  // afficher les doublons
          $scope.etudiant1 =
            { 'numero': '', 'nom': '', 'prenom': '', 'idcopie': 0 };
          $scope.choixPAGE = 5;
          ;
        }
        else if (val == 7) {  // afficher les null
          $scope.etudiant1 =
            { 'numero': '', 'nom': '', 'prenom': '', 'idcopie': 0 };
          $scope.choixPAGE = 7;
        }
        else if (val == 8) {  // afficher les étudiant : même page, même
          // étudiant !
          $scope.etudiant1 =
            { 'numero': '', 'nom': '', 'prenom': '', 'idcopie': 0 };
          $scope.choixPAGE = 8;
        }
        else if (val == 9) {  // afficher les pages du multi !  //new
          $scope.etudiant1 =
            { 'numero': '', 'nom': '', 'prenom': '', 'idcopie': 0 };
          var i = 1;
          $scope.option2 = new Array;

          for (i = 1; i <= $scope.qcmSelectionne.multi_nbpage; i++) {
            $scope.option2.push({ 'v': i, 'label': i.toString() });
          }
          $scope.nbNumero = val.nbNumero - 1;

          $scope.choixPAGE = 9;
        }
        else if (val == 6) {  // afficher les doutes
          $scope.choixPAGE = 6;
        }
        else if (val == 1) {
          $scope.choixPAGE = 1;
        }

        $scope.tableDesCopies.reload();

        return 1;
      } catch (e) {
        deferred.reject(e);
      }  // try-catch
      return deferred.promise;
    };  // fin filtre


    /************************************************************************************************/
    $scope.basculerAffichage2 = function (Copie, sens) {
      $scope.choixQCM = $rootScope.qcmSelectionne.id;

      var nbCopie = $scope.data.length;
      var nouvelle_copie;
      if (_DEBUG)
        console.info(
          'id suivant=' + Copie.id + '  sens=' + sens +
          '  nbCopie=' + nbCopie);
      for (i = 0; i < nbCopie; i++) {
        if ($scope.data[i].id == Copie.id) {
          nouvelle_copie = $scope.data[(nbCopie + i + sens) % nbCopie];
          i = 50000;
        }
      }
      if (_DEBUG)
        console.info('*** nouvelle_copie  id = ' + nouvelle_copie.id);
      $scope.basculerAffichage(nouvelle_copie);
    };
    /************************************************************************************************/
    $scope.calculDesPoint = function (caseReponse, caseSolution, numQuestion) {
      console.log("caseReponse" + caseReponse + ", caseSolution" + caseSolution + ", numQuestion" + numQuestion);
      var point, couleur;
      var vide = '(';
      if ((caseReponse == vide) &&
        ($rootScope.qcmSelectionne.modeCalcul != 2)) {
        point = $rootScope.qcmSelectionne.ptSiVide[numQuestion];
        couleur = 'white';
      } else {
        if (caseReponse == caseSolution) {
          point = $rootScope.qcmSelectionne.ptSiJuste[numQuestion];
          couleur = 'green';
        } else {  // pas tout juste, il faut regarder de + prêt
          if ($rootScope.qcmSelectionne.modeCalcul ==
            0) {  // tout juste - tout faux
            point = $rootScope.qcmSelectionne.ptSiFaux[numQuestion]
            couleur = 'grey';

          } else if (
            $rootScope.qcmSelectionne.modeCalcul ==
            1) {  // autre mode de calcul...+compliqué
            rep = caseReponse.charCodeAt(0) -
              40;  //"ABC".charCodeAt(0) // returns 65
            sol = caseSolution.charCodeAt(0) - 40;

            NbRdansSolution = 0;
            NbJdansReponse = 0;
            NbFdansReponse = 0;

            for (b = 1; b < 32; b = b * 2) {
              if ((sol & b) > 0) NbRdansSolution++;
              if ((rep & b) > 0) {
                if ((sol & b) > 0)
                  NbJdansReponse++;
                else
                  NbFdansReponse++;
              }
            }

            pt = (NbJdansReponse - NbFdansReponse) *
              $rootScope.qcmSelectionne.ptSiJuste[numQuestion] /
              NbRdansSolution;
            if (pt <= $rootScope.qcmSelectionne.ptSiFaux[numQuestion]) {
              pt = $rootScope.qcmSelectionne.ptSiFaux[numQuestion];
              couleur = '#FF4444';
            } else {
              couleur = '#ffa544';
            }
            point = pt;

          } else if (
            $rootScope.qcmSelectionne.modeCalcul ==
            2) {  // autre mode de calcul...medecine
            rep = caseReponse.charCodeAt(0) -
              40;  //"ABC".charCodeAt(0) // returns 65
            sol = caseSolution.charCodeAt(0) - 40;

            NbRdansSolution = 0;
            NbJdansReponse = 0;
            NbFdansReponse = 0;

            for (b = 1; b < 17; b = b * 2) {
              if ((sol & b) == (rep & b))
                NbJdansReponse++;
              else
                NbFdansReponse++;
            }
            if (NbRdansSolution == 0) {
            }

            pt = NbJdansReponse *
              $rootScope.qcmSelectionne.ptSiJuste[numQuestion] /
              $rootScope.qcmSelectionne.nbReponse;

            if (pt <= $rootScope.qcmSelectionne.ptSiFaux[numQuestion]) {
              couleur = '#FF4444';
            } else {
              couleur = '#ffa544';
            }
            point = pt;

          } else if (
            $rootScope.qcmSelectionne.modeCalcul ==
            3) {  // autre mode de calcul...diploma
            // console.info('-----autre mode_30 *' + caseReponse + '*');

            var rep = caseReponse - 40;  //"ABC".charCodeAt(0) // returns 65
            var sol = caseSolution - 40;

            var NbRfausse = 0;
            var NbRjuste = 0;
            var NbRdansSolution = 0;

            var pt = 0;

            for (var b = 1; b < 17; b = b * 2) {
              if ((sol & b) > 0) NbRdansSolution++;

              if (sol & b) {  // case à cocher
                if (rep & b)
                  NbRjuste++;
                else
                  NbRfausse++;

              } else {  // case à na pas cocher
                if (rep & b)
                  NbRfausse++;
                else
                  NbRjuste++;
              }
            }

            if (_DEBUG) console.info('-----numQuestion=' + numQuestion);
            if (_DEBUG) console.info('-----NbRjuste=' + NbRjuste);
            if (_DEBUG) console.info('-----NbRfausse=' + NbRfausse);
            if (_DEBUG)
              console.info('-----NbRdansSolution=' + NbRdansSolution);

            if (NbRdansSolution == 1) {
              if (NbRfausse >= 1) {
                pt = 0;  //$rootScope.qcmSelectionne.ptSiFaux[i];
              }          /*else{
                              pt = 1;//$rootScope.qcmSelectionne.ptSiJuste[i];
                          }*/
              if (_DEBUG) console.info('-----pt=' + pt);
            }

            if (NbRdansSolution > 1) {
              if (NbRfausse == 0) {
                if (_DEBUG) console.info('-----0=' + pt);
                pt = $rootScope.qcmSelectionne.ptSiJuste[numQuestion];
              } else if (NbRfausse == 1) {
                if (_DEBUG) console.info('-----1=' + pt);
                pt = $rootScope.qcmSelectionne.ptSiJuste[numQuestion] / 2;
              } else if (NbRfausse == 2) {
                if (_DEBUG) console.info('-----2=' + pt);
                pt = $rootScope.qcmSelectionne.ptSiFaux[numQuestion];
              } else {
                pt = $rootScope.qcmSelectionne.ptSiVide[numQuestion];
              }
              if (_DEBUG) console.info('-----pt=' + pt);
            }

            if (_DEBUG) console.info('-----pt=' + pt);

            if (pt <= $rootScope.qcmSelectionne.ptSiFaux[numQuestion]) {
              // pt = $rootScope.qcmSelectionne.ptSiFaux[i];
              couleur = '#FF4444';
            } else {
              couleur = '#ffa544';
            }
            point = pt;
          }
        }
      }

      return { point: point, couleur: couleur };
    };
    /************************************************************************************************/
    $scope.basculerAffichage = function (Copie) {
      if (_DEBUG) console.info('id affichage=' + Copie.id);
      if (typeof (Copie.id) == 'undefined') {
        // alert("pas ok, Copie="+typeof(Copie.id)+" et ="+ $scope.choixPAGE);
        $scope.rechargerTout();
        $scope.tableDesCopies.reload();
        $scope.choixPAGE = 1;  // liste des copies
        return;
      } else if (Copie.resultat == null) {
        str = '(';
        Copie.resultat = str.repeat(
          $rootScope.qcmSelectionne.nbQuestion);  // liste des copies
      } else if (Copie.resultat.length == 0) {
        $scope.choixPAGE = 1;  // liste des copies
        return;
      }

      // UNE SEULE COPIE
      if ($rootScope.qcmSelectionne.remord == 1)
        $scope.choixPAGE = 12;
      else
        $scope.choixPAGE = 0;

      $scope.Copie = Copie;
      $scope.copieDoute = [];
      new services.copieDoute(Copie.id).then(function (data) {
        $scope.copieDoute = data.data;
        var lg = $scope.copieDoute.length;
        var v = '';
        for (i = 0; i < lg; i++) {
          v = $scope.copieDoute[i].question;
          // alert("v="+v)
          $scope.dataCopie[v - 1].doute = '#c48e42';
        }
      });


      // trouver étudiant de la copie
      nbEtudiant = $rootScope.qcmSelectionne.listeEtudiant.length;
      trouve = false;
      for (i = 0; i < nbEtudiant && !trouve; i++) {
        if (Copie.idetudiant ==
          $rootScope.qcmSelectionne.listeEtudiant[i].idetudiant) {
          // alert('???'+i)
          trouve = true;
        }
      }
      // alert('ok'+trouve)
      if (trouve)
        $scope.etudiantCopie = $rootScope.qcmSelectionne.listeEtudiant[i];
      else
        $scope.etudiantCopie = {};

      // pour remplir le tableau des cases réponses
      $scope.page = Copie.page;

      $scope.dataCopie = new Array;
      $scope.tabSolution = new Array;

      if (_DEBUG) console.info('reponse de la copie = ' + Copie.resultat);

      if ($rootScope.qcmSelectionne.multi_nbpage > 0) {
        if (Copie.page < 1 || Copie.page > $rootScope.qcmSelectionne.page) {
          str = '(';
          Copie.resultat = str.repeat(
            $rootScope.qcmSelectionne.nbQuestion);  // liste des copies
        }
      }

      if (_DEBUG) console.info('AVANT page =' + Copie.page);
      if ($rootScope.qcmSelectionne.remord == 1) {
        $scope.tabSolution =
          SolTab2JsonRemord($rootScope.qcmSelectionne.qcmSolution);
        $scope.dataCopie = SolTab2JsonRemord(Copie.reponseRemord);
        nbQ = $scope.tabSolution.length;
        for (i = 0; i < nbQ; i++) {  // pas de remord...
          $scope.dataCopie[2 * i].solution = $scope.tabSolution[i].reponse;
          $scope.dataCopie[2 * i + 1].solution =
            $scope.tabSolution[i].reponse;
        }
      } else {
        $scope.dataCopie = SolTab2Json(Copie.resultat);
      }

      /// SolTab2Json(Copie.resultat, $scope.dataCopie)
      /*new ServiceQcm.SolTab2Json(Copie.resultat).then(function(data){

          $scope.dataCopie = data
      */
      $scope.NbJdansReponse = 0;
      $scope.NbFdansReponse = 0;
      $scope.NbVdansReponse = 0;
      if ($rootScope.qcmSelectionne.multi_nbpage == 0) {  // simple
        if ($rootScope.qcmSelectionne.remord == 0) {      // simple

          $scope.tabSolution =
            SolTab2Json($rootScope.qcmSelectionne.qcmSolution);

          var vide = '_'.repeat(5);

          for (i = 0; i < $scope.tabSolution.length; i++) {
            // alert('ok i='+i)
            $scope.dataCopie[i].solution = $scope.tabSolution[i].reponse;
            $scope.dataCopie[i].doute = 0;

            if (($scope.dataCopie[i]['reponse'] == vide) &&
              ($rootScope.qcmSelectionne.modeCalcul != 2)) {
              $scope.dataCopie[i]['point'] =
                $rootScope.qcmSelectionne.ptSiVide[i];
              $scope.dataCopie[i]['couleur'] = 'white';
              $scope.NbVdansReponse++;
            } else {
              if ($scope.dataCopie[i]['reponse'] ==
                $scope.dataCopie[i].solution) {
                $scope.dataCopie[i]['point'] =
                  $rootScope.qcmSelectionne.ptSiJuste[i];
                $scope.dataCopie[i]['couleur'] = '#60D660';
                $scope.NbJdansReponse++;
              } else {  // pas tout juste, il faut regarder de + prêt
                $scope.NbFdansReponse++;
                if ($rootScope.qcmSelectionne.modeCalcul ==
                  0) {  // tout juste - tout faux
                  $scope.dataCopie[i]['point'] =
                    $rootScope.qcmSelectionne.ptSiFaux[i]
                  $scope.dataCopie[i]['couleur'] = '#FF4444';

                } else if (
                  $rootScope.qcmSelectionne.modeCalcul ==
                  1) {  // autre mode de calcul...+compliqué
                  rep = Copie.resultat.charCodeAt(i) -
                    40;  //"ABC".charCodeAt(0) // returns 65
                  sol = $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i) -
                    40;

                  NbRdansSolution = 0;
                  NbJdansReponse = 0;
                  NbFdansReponse = 0;

                  for (b = 1; b < 32; b = b * 2) {
                    if ((sol & b) > 0) NbRdansSolution++;
                    if ((rep & b) > 0) {
                      if ((sol & b) > 0)
                        NbJdansReponse++;
                      else
                        NbFdansReponse++;
                    }
                  }

                  pt = (NbJdansReponse - NbFdansReponse) *
                    $rootScope.qcmSelectionne.ptSiJuste[i] /
                    NbRdansSolution;
                  if (pt <= $rootScope.qcmSelectionne.ptSiFaux[i]) {
                    pt = $rootScope.qcmSelectionne.ptSiFaux[i];
                    $scope.dataCopie[i]['couleur'] = '#FF4444';
                  } else {
                    $scope.dataCopie[i]['couleur'] = '#ffa544';
                  }
                  $scope.dataCopie[i]['point'] = pt;

                } else if (
                  $rootScope.qcmSelectionne.modeCalcul ==
                  2) {  // autre mode de calcul...medecine
                  rep = Copie.resultat.charCodeAt(i) -
                    40;  //"ABC".charCodeAt(0) // returns 65
                  sol = $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i) -
                    40;

                  NbRdansSolution = 0;
                  NbJdansReponse = 0;
                  NbFdansReponse = 0;

                  for (b = 1; b < 17; b = b * 2) {
                    if ((sol & b) == (rep & b))
                      NbJdansReponse++;
                    else
                      NbFdansReponse++;
                  }
                  if (NbRdansSolution == 0) {
                  }

                  pt = NbJdansReponse *
                    $rootScope.qcmSelectionne.ptSiJuste[i] /
                    $rootScope.qcmSelectionne.nbReponse;

                  if (pt <= $rootScope.qcmSelectionne.ptSiFaux[i]) {
                    $scope.dataCopie[i]['couleur'] = '#FF4444';
                  } else {
                    $scope.dataCopie[i]['couleur'] = '#ffa544';
                  }
                  $scope.dataCopie[i]['point'] = pt;

                } else if (
                  $rootScope.qcmSelectionne.modeCalcul ==
                  3) {  // autre mode de calcul...diploma
                  if (_DEBUG) console.info('-----autre mode_30');

                  var rep = $scope.Copie.resultat.charCodeAt(i) -
                    40;  //"ABC".charCodeAt(0) // returns 65
                  var sol =
                    $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i) -
                    40;

                  var NbRfausse = 0;
                  var NbRjuste = 0;
                  var NbRdansSolution = 0;

                  var pt = 0;

                  for (var b = 1; b < 17; b = b * 2) {
                    if ((sol & b) > 0) NbRdansSolution++;

                    if (sol & b) {  // case à cocher
                      if (rep & b)
                        NbRjuste++;
                      else
                        NbRfausse++;

                    } else {  // case à na pas cocher
                      if (rep & b)
                        NbRfausse++;
                      else
                        NbRjuste++;
                    }
                  }

                  if (_DEBUG) console.info('-----i=' + i);
                  if (_DEBUG) console.info('-----NbRjuste=' + NbRjuste);
                  if (_DEBUG)
                    console.info('-----NbRfausse=' + NbRfausse);
                  if (_DEBUG)
                    console.info(
                      '-----NbRdansSolution=' + NbRdansSolution);

                  if (NbRdansSolution == 1) {
                    if (NbRfausse >= 1) {
                      pt = 0;  //$rootScope.qcmSelectionne.ptSiFaux[i];
                    }          /*else{
                                    pt = 1;//$rootScope.qcmSelectionne.ptSiJuste[i];
                                }*/
                    if (_DEBUG) console.info('-----pt=' + pt);
                  }

                  if (NbRdansSolution > 1) {
                    if (NbRfausse == 0) {
                      if (_DEBUG) console.info('-----0=' + pt);
                      pt = $rootScope.qcmSelectionne.ptSiJuste[i];
                    } else if (NbRfausse == 1) {
                      if (_DEBUG) console.info('-----1=' + pt);
                      pt = $rootScope.qcmSelectionne.ptSiJuste[i] / 2;
                    } else if (NbRfausse == 2) {
                      if (_DEBUG) console.info('-----2=' + pt);
                      pt = $rootScope.qcmSelectionne.ptSiFaux[i];
                    } else {
                      pt = $rootScope.qcmSelectionne.ptSiVide[i];
                    }
                    if (_DEBUG) console.info('-----pt=' + pt);
                  }

                  if (_DEBUG) console.info('-----pt=' + pt);

                  if (pt <= $rootScope.qcmSelectionne.ptSiFaux[i]) {
                    // pt = $rootScope.qcmSelectionne.ptSiFaux[i];
                    $scope.dataCopie[i]['couleur'] = '#FF4444';
                  } else {
                    $scope.dataCopie[i]['couleur'] = '#ffa544';
                  }
                  $scope.dataCopie[i]['point'] = pt;
                }
              }
            }
          }
        } else {  // simple avec remord, initialisation du tableau dataCopie
          // (=affichage)

          var vide = '_'.repeat(5);

          nbQ = $scope.tabSolution.length;
          //alert('nbQ=' + nbQ);
          for (i = 0; i < nbQ; i++) {
            // pas de remord...
            if ($scope.dataCopie[2 * i + 1]['reponse'] == vide) {
              $scope.dataCopie[2 * i + 1]['point'] = '--';
              $scope.dataCopie[2 * i + 1]['solution'] = '--';
              $scope.dataCopie[2 * i + 1]['couleur'] = 'white';

              // alert("tt="+JSON.stringify($rootScope.qcmSelectionne));
              var pc = $scope.calculDesPoint(
                Copie.reponseRemord.charCodeAt(2 * i),
                $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i), i);
              // alert("tt="+JSON.stringify($scope.dataCopie));
              // alert("i="+i+" et pc="+JSON.stringify(pc));
              $scope.dataCopie[2 * i]['point'] = pc.point;
              $scope.dataCopie[2 * i]['solution'] =
                $scope.tabSolution[i].reponse;
              $scope.dataCopie[2 * i]['couleur'] = pc.couleur;
            } else {  // il y a une réponse de remord...
              var pc = $scope.calculDesPoint(
                Copie.reponseRemord.charCodeAt(2 * i + 1),
                $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i), i);
              // remord
              $scope.dataCopie[2 * i + 1]['point'] = pc.point;
              $scope.dataCopie[2 * i + 1]['solution'] =
                $scope.tabSolution[i].reponse;
              $scope.dataCopie[2 * i + 1]['couleur'] = pc.couleur;
              // reponse non valide
              $scope.dataCopie[2 * i]['point'] = '-';
              $scope.dataCopie[2 * i]['solution'] = '--';
              $scope.dataCopie[2 * i]['couleur'] = '#d6d6c2';
            }
          }
        }


      } else {  // multi

        var page
        if (Copie.page < 1) {
          page = 1;
          // if (_DEBUG) console.info('ERREUR')
        }
        else if (Copie.page > $rootScope.qcmSelectionne.page) {
          page = 1;
          // if (_DEBUG) console.info('ERREUR')
        }
        else { page = Copie.page } var nbQPage =
          $rootScope.qcmSelectionne.PremiereQuestionPageTab[page - 1];
        var nbQPageS =
          $rootScope.qcmSelectionne.PremiereQuestionPageTab[page];
        if (_DEBUG)
          console.info(
            'page =' + page + '  : question entre ' + nbQPage + '  et  ' +
            nbQPageS);
        if (_DEBUG)
          console.info(
            'APRES $rootScope.qcmSelectionne.qcmSolution:\n' +
            $rootScope.qcmSelectionne.qcmSolution);
        if (_DEBUG)
          console.info(
            'APRES $rootScope.qcmSelectionne.qcmSolution tronqué=' +
            $rootScope.qcmSelectionne.qcmSolution.substring(
              nbQPage, nbQPageS));
        var extrait =
          $rootScope.qcmSelectionne.qcmSolution.substring(nbQPage, nbQPageS)
        // var nbQuestion =
        // $rootScope.qcmSelectionne.PremiereQuestionPageTab[page] -
        // $rootScope.qcmSelectionne.PremiereQuestionPageTab[page-1]
        //$scope.tabSolution = $scope.SolTab2Json(extrait)
        if (_DEBUG) console.info('extrait=  ' + extrait);

        $scope.tabSolution = SolTab2Json(extrait)
        /// SolTab2Json(extrait, $scope.tabSolution)

        if (_DEBUG) console.info(
          'page =' + page + ' entre ' + nbQPage + '  et  ' + nbQPageS);
        var vide = '_'.repeat(5);

        for (i = 0; i < $scope.tabSolution.length; i++) {
          // le i=l'indice de la question pour la page affichée (0, 1, 2, 3,
          // 4, 5, 6...) le iQuestion=l'indice de la question pour le qcm (0,
          // 1, 2, 3, 4, 5, 6, 7, 8, 9, 10)
          var iQuestion = i +
            $rootScope.qcmSelectionne
              .PremiereQuestionPageTab[$scope.Copie.page - 1];


          // alert('ok i='+i)
          $scope.dataCopie[i].solution = $scope.tabSolution[i].reponse;
          $scope.dataCopie[i].doute = 0;

          if (($scope.dataCopie[i]['reponse'] == vide) &&
            ($rootScope.qcmSelectionne.modeCalcul != 2)) {
            $scope.dataCopie[i]['point'] =
              $rootScope.qcmSelectionne.ptSiVide[i + nbQPage];
            $scope.dataCopie[i]['couleur'] = 'white';
            $scope.NbVdansReponse++;
          } else {
            if ($scope.dataCopie[i]['reponse'] ==
              $scope.dataCopie[i].solution) {
              $scope.dataCopie[i]['point'] =
                $rootScope.qcmSelectionne.ptSiJuste[i + nbQPage];
              $scope.dataCopie[i]['couleur'] = '#60D660';
              $scope.NbJdansReponse++;
            } else {
              $scope.NbFdansReponse++;

              if ($rootScope.qcmSelectionne.modeCalcul ==
                0) {  // tout juste - tout faux
                $scope.dataCopie[i]['point'] =
                  $rootScope.qcmSelectionne.ptSiFaux[i + nbQPage];
                $scope.dataCopie[i]['couleur'] = '#FF4444';

              } else if (
                $rootScope.qcmSelectionne.modeCalcul ==
                1) {  // autre mode de calcul...+compliqué
                rep = Copie.resultat.charCodeAt(i) -
                  40;  //"ABC".charCodeAt(0) // returns 65
                sol = $rootScope.qcmSelectionne.qcmSolution.charCodeAt(
                  i + nbQPage) -
                  40;
                if (_DEBUG)
                  console.info('calcul mode1: sol=' + sol + '   rep=' + rep);

                NbRdansSolution = 0;
                NbJdansReponse = 0;
                NbFdansReponse = 0;

                for (b = 1; b < 32; b = b * 2) {
                  if ((sol & b) > 0) NbRdansSolution++;
                  if ((rep & b) > 0) {
                    if ((sol & b) > 0)
                      NbJdansReponse++;
                    else
                      NbFdansReponse++;
                  }
                }
                /*
                if (i==3) if (_DEBUG)
                console.info('NbRdansSolution='+NbRdansSolution) if (i==3) if
                (_DEBUG) console.info('NbJdansReponse='+NbJdansReponse) if
                (i==3) if (_DEBUG)
                console.info('NbFdansReponse='+NbFdansReponse)
                */
                pt = (NbJdansReponse - NbFdansReponse) *
                  $rootScope.qcmSelectionne.ptSiJuste[i + nbQPage] /
                  NbRdansSolution;
                if (pt <= $rootScope.qcmSelectionne.ptSiFaux[i + nbQPage]) {
                  pt = $rootScope.qcmSelectionne.ptSiFaux[i + nbQPage];
                  $scope.dataCopie[i]['couleur'] = '#FF4444';
                } else {
                  $scope.dataCopie[i]['couleur'] = '#ffa544';
                }
                $scope.dataCopie[i]['point'] = pt;

              } else if (
                $rootScope.qcmSelectionne.modeCalcul ==
                2) {  // autre mode de calcul...medecine
                rep = Copie.resultat.charCodeAt(i) -
                  40;  //"ABC".charCodeAt(0) // returns 65
                sol =
                  $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i) - 40;
                if (_DEBUG)
                  console.info('calcul mode2: sol=' + sol + '   rep=' + rep);

                NbRdansSolution = 0;
                NbJdansReponse = 0;
                NbFdansReponse = 0;

                for (b = 1; b < 17; b = b * 2) {
                  if ((sol & b) == (rep & b))
                    NbJdansReponse++;
                  else
                    NbFdansReponse++;
                }
                if (NbRdansSolution == 0) {
                }

                pt = NbJdansReponse *
                  $rootScope.qcmSelectionne.ptSiJuste[i + nbQPage] /
                  qcmSelectionne.nbReponse;

                if (pt <= $rootScope.qcmSelectionne.ptSiFaux[i + nbQPage]) {
                  $scope.dataCopie[i]['couleur'] = '#FF4444';
                } else {
                  $scope.dataCopie[i]['couleur'] = '#ffa544';
                }
                $scope.dataCopie[i]['point'] = pt;
              }
            }
          }
        }
      }
    };
    /***********************************************************************/
    $scope.SupDoute = function () {
      if (typeof ($scope.Copie) == 'undefined') {
        $scope.choixPAGE = 1;  // liste des copie
      } else {
        $scope.afficheEtudiant = 0;
        $scope.Copie.doute = 0;
        services.effacerDoute($scope.Copie.id);  // 8 ou 2 -> 0
      }
    };
    /***********************************************************************/
    $scope.verifierEtudiant = function () {
      if ($scope.afficheEtudiant == 0)
        $scope.afficheEtudiant = 1;
      else
        $scope.afficheEtudiant = 0;
    };

    /***********************************************************************/
    $scope.analyse = function (copie) {
      if (typeof (copie.id) == 'undefined') {
        // alert("pas ok, Copie="+typeof(Copie.id)+" et ="+ $scope.choixPAGE);
        $scope.choixPAGE = 1;  // liste des copie
      } else {
        $scope.choixPAGE = 6;  // analyse
        $scope.rd = Date.now();
        $scope.Copie = copie;
        $scope.x100 = 0;
        $scope.y100 = 0;
        $scope.point = {
          'form_NOx': '',
          'form_NOy': '',
          'form_SOx': '',
          'form_NEx': '',
          'form_NEy': '',
          'form_SEx': '',
          'form_SEy': ''
        };
      }
    };
    /***********************************************************************/
    $scope.erreur = function (copie) {
      if (typeof (copie.id) == 'undefined') {
        // alert("pas ok, Copie="+typeof(Copie.id)+" et ="+ $scope.choixPAGE);
        $scope.choixPAGE = 1;  // liste des copie
      } else {
        $scope.basculerAffichage(copie);
        $scope.choixPAGE = 10;  // erreur !
      }
    };


    /************************************************************************************************/
    $scope.effacer = function (Copie) {
      if (typeof (Copie.id) == 'undefined') {
        // alert("pas ok, Copie="+typeof(Copie.id)+" et ="+ $scope.choixPAGE);
        $scope.choixPAGE = 1;  // liste des copie
      } else {
        services.effacerCopie($rootScope.qcmSelectionne.id, Copie.id);
        $scope.Copie = Copie;

        $rootScope.qcmSelectionne.listeCopie.splice(
          $rootScope.qcmSelectionne.listeCopie.indexOf(Copie), 1);
        // fctService.effaceCopie(Copie);
        $scope.listeCopie = $rootScope.qcmSelectionne.listeCopie;
        $scope.data.splice($scope.data.indexOf(Copie), 1);
        $scope.tableDesCopies.reload();
      }
    };

    /************************************************************************************************/
    $scope.point_it = function (event) {
      if ($scope.x100 == 0) {
        $scope.x100 = document.getElementById('px')
          .innerHTML;  // largeur de l'image réelle
        $scope.y100 = document.getElementById('py').innerHTML;

        $scope.xr = 500;  // largeur de l'image affichée
        $scope.yr = $scope.xr * $scope.y100 / $scope.x100;
      }

      var pos_x = event.offsetX ?
        (event.offsetX) :
        event.pageX - document.getElementById('pointer_div').offsetLeft;
      var pos_y = event.offsetY ?
        (event.offsetY) :
        event.pageY - document.getElementById('pointer_div').offsetTop;

      document.getElementById('cross').style.left = (pos_x - 1);
      document.getElementById('cross').style.top = (pos_y - 15);
      document.getElementById('cross').style.visibility = 'visible';
      $scope.form_x = (pos_x * $scope.x100) / $scope.xr;
      $scope.form_y = (pos_y * $scope.y100) / $scope.yr;

      var x = (pos_x * $scope.x100) / $scope.xr;
      var y = (pos_y * $scope.y100) / $scope.yr;
      if (x < ($scope.x100 / 2)) {    // ouest
        if (y < ($scope.y100 / 2)) {  // haut
          $scope.point.form_NOx = (pos_x * $scope.x100) / $scope.xr;
          $scope.point.form_NOy = (pos_y * $scope.y100) / $scope.yr;
        } else {
          $scope.point.form_SOx = (pos_x * $scope.x100) / $scope.xr;
          $scope.point.form_SOy = (pos_y * $scope.y100) / $scope.yr;
        }
      } else {
        if (y < $scope.y100 / 2) {  // haut
          $scope.point.form_NEx = (pos_x * $scope.x100) / $scope.xr;
          $scope.point.form_NEy = (pos_y * $scope.y100) / $scope.yr;
        } else {
          $scope.point.form_SEx = (pos_x * $scope.x100) / $scope.xr;
          $scope.point.form_SEy = (pos_y * $scope.y100) / $scope.yr;
        }
      }
    };

    /************************************************************************************************/
    $scope.verifier = function (cas) {
      // cas = 1 refaire l'analyse
      // cas = 2 inverser/refaire l'analyse

      if (cas == 1 || cas == 1000) {
        if ($scope.point.form_NOx == '' || $scope.point.form_NOy == '') {
          alert('trouver le point NO');
          return false;
        }
        if ($scope.point.form_SOx == '' || $scope.point.form_SOy == '') {
          alert('trouver le point SO');
          return false;
        }
        if ($scope.point.form_NEx == '' || $scope.point.form_NEy == '') {
          alert('trouver le point NE');
          return false;
        }
        if ($scope.point.form_SEx == '' || $scope.point.form_SEy == '') {
          alert('trouver le point SE');
          return false;
        }
        // alert('traitement !')
        /*var nbQ;
        if ($rootScope.qcmSelectionne.nbpage==0)
        nbQ=$rootScope.qcmSelectionne.nbQuestion else { nbQ=0; for (i=1;
        i<=$rootScope.qcmSelectionne.PremiereQuestionPageTab.length; i++){
                nb=$rootScope.qcmSelectionne.PremiereQuestionPageTab[i]-$rootScope.qcmSelectionne.PremiereQuestionPageTab[i-1]
                if (nbQ<$rootScope.qcmSelectionne.nombrePageTab[i])
        nbQ=$rootScope.qcmSelectionne.nombrePageTab[i]
            }
        }*/
        if (cas == 1) {
          $scope.loader = 1;

          $scope.Copie.nbNumero = $rootScope.qcmSelectionne.nbNumero;

          services
            .correction(
              $rootScope.qcmSelectionne, $scope.Copie, $scope.point)
            .then(function (data) {
              // il faut recharger : la copie- la moyenne...
              $scope.rechargerTout();
              //$scope.qcmSelectionne.moyenne = fctService.calculNotes();
              $scope.loader = 0;

              $scope.choixPAGE = 1;  // liste des copie
            })
            .catch(function (response) {
              if (_DEBUG)
                console.info(
                  'message=' + response.data.message +
                  ' et =' + response.status);
              // throw(response);
              toastr.error('___problème___');
              $scope.loader = 0;

              $scope.rechargerTout();
            });

        } else {  // cas =1000 : on corrige toutes les copies avec la même
          // erreur que la copie...

          var doute = $scope.Copie.doute;
          if (doute == 0)
            return;  // ne pas lancer la corectio sur ttes les copies ok !!!

          var nb = $rootScope.qcmSelectionne.listeCopie.length;
          var nb_a_corriger = 0;
          for (var i = 0; i < nb; i++) {
            if (_DEBUG)
              console.info(
                $rootScope.qcmSelectionne.listeCopie[i].doute +
                ' et =' + doute);
            if ($rootScope.qcmSelectionne.listeCopie[i].doute == doute) {
              nb_a_corriger++;
            }
          }
          alert('___nombre de copie à corriger___ : ' + nb_a_corriger);
          $scope.loader = 1;

          for (var i = 0; i < nb; i++) {
            if ($rootScope.qcmSelectionne.listeCopie[i].doute == doute) {
              var une_copie = $rootScope.qcmSelectionne.listeCopie[i];
              une_copie.nbNumero = $rootScope.qcmSelectionne.nbNumero;
              services
                .correction(
                  $rootScope.qcmSelectionne, une_copie, $scope.point)
                .then(function (data) {
                  nb_a_corriger--;
                  if (_DEBUG)
                    console.info(' 1.nb_a_corriger =' + nb_a_corriger);
                  // il faut recharger : la copie- la moyenne...
                  //$scope.qcmSelectionne.moyenne =
                  // fctService.calculNotes();
                  if (nb_a_corriger == 0) {
                    if (_DEBUG)
                      console.info(' fin.nb_a_corriger =' + nb_a_corriger);
                    $scope.loader = 0;
                    $scope.choixPAGE = 1;  // liste des copie
                    $scope.loader = 0;
                    $scope.rechargerTout();
                  }
                })
                .catch(function (response) {
                  if (_DEBUG)
                    console.info(
                      'message=' + response.data.message +
                      ' et =' + response.status);
                  if (_DEBUG)
                    console.info(' 3.nb_a_corriger =' + nb_a_corriger);
                  // throw(response);
                  nb_a_corriger--;
                  if (nb_a_corriger == 0) {
                    $scope.loader = 0;
                    $scope.choixPAGE = 1;  // liste des copie
                    $scope.rechargerTout();
                  }
                  // toastr.error("___problème___");
                  //$scope.rechargerTout();
                });
            }
          }
        }
      }
      if (cas == 2) {
        // alert('inverser !')
        // il faut recharger : la copie- la moyenne...
        $scope.Copie.nbNumero = $rootScope.qcmSelectionne.nbNumero;
        services.inversion($rootScope.qcmSelectionne, $scope.Copie)
          .then(function (data) {
            //$scope.qcmSelectionne.moyenne = fctService.calculNotes();
            $scope.choixPAGE = 1;  // liste des copie
            // new ServiceQcm.initListeEtudiant($rootScope.qcmSelectionne)
            // new ServiceQcm.calculNotes($rootScope.qcmSelectionne);
            $scope.rechargerTout();
          });
      }
    };

    /*
    function verifier(f){
        if (f.form_NOx.value == "" || f.form_NOy.value == ""){ alert ('trouver
    le point NO');return false;} if (f.form_SOx.value == "" ||
    f.form_SOy.value == ""){ alert ('trouver le point SO');return false;} if
    (f.form_NEx.value == "" || f.form_NEy.value == ""){ alert ('trouver le
    point NE');return false;} if (f.form_SEx.value == "" || f.form_SEy.value
    == ""){ alert ('trouver le point SE');return false;} return true;
    }
    */

    /************************************************************************************************/
    /// SolTab2Json = function(chaineResultat, TABresultat){
    var SolTab2Json = function (chaineResultat) {
      var deferred = $q.defer();

      try {
        //$scope.choixPAGE=0; //une seule copie, à voir
        var lg = chaineResultat.length;
        // var lg=$rootScope.nbQuestion;
        // if (_DEBUG) console.info('SolTab2Json: lg='+lg+'   et
        // chaine='+chaineResultat)
        var tabRes = new Array();
        var v;
        var memberfilter2 = new Array();
        memberfilter2[0] = 'num';
        var memberfilter = new Array();
        memberfilter[0] = 'num';
        memberfilter[1] = 'A';
        memberfilter[2] = 'B';
        memberfilter[3] = 'C';
        memberfilter[4] = 'D';
        memberfilter[5] = 'E';
        memberfilter[6] = 'reponse';
        memberfilter[7] = 'solution';
        memberfilter[8] = 'point';
        memberfilter[9] = 'couleur';

        var rep = new Object();
        rep.num = 1000;
        var jsonText2 = JSON.stringify(rep, memberfilter2, '');
        ;
        var my_JSON_object2 =
          !(/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(
            jsonText2.replace(/"(\\.|[^"\\])*"/g, ''))) &&
          eval('(' + jsonText2 + ')');
        ;

        var jsonText;
        var my_JSON_object;

        // var
        // decalage=$rootScope.qcmSelectionne.PremiereQuestionPageTab[page-1]
        for (i = 0; i < lg; i++) {
          v = chaineResultat.charCodeAt(i) - 40;

          rep.num = i + 1;
          rep.A = (v & 1) > 0;
          rep.B = (v & 2) > 0;
          rep.C = (v & 4) > 0;
          rep.D = (v & 8) > 0;
          rep.E = (v & 16) > 0;

          rep.reponse = ''
          rep.point = ''
          rep.couleur = ''
          rep.solution = ''
          if (rep.A) rep.reponse += 'A'
          else rep.reponse += '_'
          if (rep.B) rep.reponse += 'B'
          else rep.reponse += '_'
          if (rep.C) rep.reponse += 'C'
          else rep.reponse += '_'
          if (rep.D) rep.reponse += 'D'
          else rep.reponse += '_'
          if (rep.E) rep.reponse += 'E'
          else rep.reponse += '_'

          jsonText = JSON.stringify(rep, memberfilter, '');
          my_JSON_object = !(/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(
            jsonText.replace(/"(\\.|[^"\\])*"/g, ''))) &&
            eval('(' + jsonText + ')');
          tabRes.push(my_JSON_object);
          tableau = tabRes
        }
        if (_DEBUG)
          console.info(
            '*** SolTab2Json  lg=' + lg + '   -  i=' + i +
            '   -  tabRes=' + tabRes.length)
        /// return tabRes;
        /// TABresultat = tabRes
        deferred.resolve(tabRes);

      } catch (e) {
        deferred.reject(e);
      }  // try-catch
      return tabRes;
      // return deferred.promise
    };
    /*********************************************************************************/

    /************************************************************************************************/
    /// SolTab2Json = function(chaineResultat, TABresultat){
    var SolTab2JsonRemord = function (chaineResultat) {
      var deferred = $q.defer();

      try {
        //$scope.choixPAGE=0; //une seule copie, à voir
        var lg = chaineResultat.length;
        // var lg=$rootScope.nbQuestion;
        // if (_DEBUG) console.info('SolTab2Json: lg='+lg+'   et
        // chaine='+chaineResultat)
        var tabRes = new Array();
        var v;
        var memberfilter2 = new Array();
        memberfilter2[0] = 'num';
        var memberfilter = new Array();
        memberfilter[0] = 'num';
        memberfilter[1] = 'A';
        memberfilter[2] = 'B';
        memberfilter[3] = 'C';
        memberfilter[4] = 'D';
        memberfilter[5] = 'E';
        memberfilter[6] = 'reponse';
        memberfilter[7] = 'solution';
        memberfilter[8] = 'point';
        memberfilter[9] = 'couleur';

        var rep = new Object();
        rep.num = 1000;
        var jsonText2 = JSON.stringify(rep, memberfilter2, '');
        ;
        var my_JSON_object2 =
          !(/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(
            jsonText2.replace(/"(\\.|[^"\\])*"/g, ''))) &&
          eval('(' + jsonText2 + ')');
        ;

        var jsonText;
        var my_JSON_object;

        // var
        // decalage=$rootScope.qcmSelectionne.PremiereQuestionPageTab[page-1]
        for (i = 0; i < lg; i++) {
          v = chaineResultat.charCodeAt(i) - 40;

          rep.num = (i + 1) | 0;  // partie entière
          rep.A = (v & 1) > 0;
          rep.B = (v & 2) > 0;
          rep.C = (v & 4) > 0;
          rep.D = (v & 8) > 0;
          rep.E = (v & 16) > 0;

          rep.reponse = ''
          rep.point = ''
          rep.couleur = ''
          rep.solution = ''
          if (rep.A) rep.reponse += 'A'
          else rep.reponse += '_'
          if (rep.B) rep.reponse += 'B'
          else rep.reponse += '_'
          if (rep.C) rep.reponse += 'C'
          else rep.reponse += '_'
          if (rep.D) rep.reponse += 'D'
          else rep.reponse += '_'
          if (rep.E) rep.reponse += 'E'
          else rep.reponse += '_'

          jsonText = JSON.stringify(rep, memberfilter, '');
          my_JSON_object = !(/[^,:{}\[\]0-9.\-+Eaeflnr-u \n\r\t]/.test(
            jsonText.replace(/"(\\.|[^"\\])*"/g, ''))) &&
            eval('(' + jsonText + ')');
          tabRes.push(my_JSON_object);
          tableau = tabRes
        }
        if (_DEBUG)
          console.info(
            '*** SolTab2Json  lg=' + lg + '   -  i=' + i +
            '   -  tabRes=' + tabRes.length)
        /// return tabRes;
        /// TABresultat = tabRes
        // deferred.resolve(tabRes);
        deferred.resolve(tableau);

      } catch (e) {
        deferred.reject(e);
      }  // try-catch
      return tabRes;
      // return deferred.promise
    };
    /*********************************************************************************/
    /*
          $scope.majListeCopie= function(){

            //services.listeCopie($rootScope.qcmSelectionne.id).then(function(data){
            //  $rootScope.listeCopie = data.data;
            if ($rootScope.qcmSelectionne.listeCopie.length>0){

                resCopie = $rootScope.qcmSelectionne.listeCopie;
                nbcopies = $rootScope.qcmSelectionne.listeCopie.length;

                somme = 0;sommePtJuste=0;
                for (nbC = 0 ; (nbC < nbcopies); nbC++) {   // toutes les
          copies et pour toutes les questions ! sommeC = 0; for (nbQ = 0 ;
          (nbQ < $rootScope.qcmSelectionne.nbQuestion); nbQ++) { c =
          resCopie[nbC].resultat.charAt(nbQ); if (nbC==0)
          sommePtJuste+=$rootScope.qcmSelectionne.ptSiJuste[nbQ] ; if
          ($rootScope.qcmSelectionne.modeCalcul==0){

                            if (c=='('){   //pas de reponse, ça ne change
       rien
                                //pas de reponse, ça ne change rien
                                sommeC = sommeC +
          $rootScope.qcmSelectionne.ptSiVide[nbQ] ;//normalement = 0
                            }else{//tester la reponse
                                if
          (c==$rootScope.qcmSelectionne.qcmSolution.charAt(nbQ)){  // il
       avait faux, il a juste sommeC = sommeC +
          $rootScope.qcmSelectionne.ptSiJuste[nbQ] ;

                                }else{  // il avait juste, il a faux
                                    sommeC = sommeC +
          $rootScope.qcmSelectionne.ptSiFaux[nbQ];
                                }
                            }
                        }else if($rootScope.qcmSelectionne.modeCalcul==1){

                            // implémenter calcul "spécial !!!"






                        }

                    }
                    if (sommeC < 0) sommeC = 0;

                    $rootScope.qcmSelectionne.listeCopie[nbC].note20 =
       sommeC / (sommePtJuste)*20;
                    $rootScope.qcmSelectionne.listeCopie[nbC].nbPoint =
          sommeC;

                    somme = somme + sommeC;
                }
                $rootScope.qcmSelectionne.moyenne = somme*20/nbcopies/nbQ;
                $rootScope.qcmSelectionne.note = somme;
                $rootScope.qcmSelectionne.Nbcopies = nbcopies;
                $scope.data = $rootScope.qcmSelectionne.listeCopie;
            }


            //});
            //return $rootScope.qcmSelectionne.listeCopie;
          };//majListeCopie

        */

    /************************************************************************************************/
    $scope.$watch('dataCopie',
      async function (newValue, oldValue) {  // pour 44
        // : de [0]
        // à
        // [44-1]...
        if (typeof (newValue) == 'undefined') {
          return;
        }
        if (typeof (oldValue) == 'undefined') {
          return;
        }

        if ($scope.changement_en_cours == 1) return;

        var trouve = false, nbQ = $rootScope.qcmSelectionne.nbQuestion, i = 0,
          lettre = 0;

        if ($rootScope.qcmSelectionne.remord == 1) nbQ = 2 * nbQ;

        var decoche = false
        //if (debug) console.log('debut cop.js');

        // on cherche la croix cochée... la différence !
        for (i = 0; (i < nbQ) && !trouve; i++) {
          if (!(newValue[i].A == oldValue[i].A)) {  // alert('A'+(i+1));
            lettre = 1;
            trouve = true;
            if (newValue[i].A == false) decoche = true;
          }
          if (!(newValue[i].B == oldValue[i].B)) {  // alert('B'+(i+1));
            lettre = 2;
            trouve = true;
            if (newValue[i].B == false) decoche = true;
          }
          if (!(newValue[i].C == oldValue[i].C)) {  // alert('C'+(i+1));
            lettre = 3;
            trouve = true;
            if (newValue[i].C == false) decoche = true;
          }
          if (!(newValue[i].D == oldValue[i].D)) {  // alert('D'+(i+1));
            lettre = 4;
            trouve = true;
            if (newValue[i].D == false) decoche = true;
          }
          if (!(newValue[i].E == oldValue[i].E)) {  // alert('E'+(i+1));
            lettre = 5;
            trouve = true;
            if (newValue[i].E == false) decoche = true;
          }
        }
        // i = l'indice de la case cochée !!!!!!!!!
        // alert('new = '+newValue[i].A);
        // nouvelle chaine "solution"
        // console.log('newvalue[i] = ' + newValue[i]);
        // alert("debutApres decoche="+decoche+" lettre="+lettre)
        // console.log('i = '+i);
        if (trouve) {
          if (!decoche) {
            // cas n°1 : une seule réponse par question
            // on décoche les autres croix
            if ($rootScope.qcmSelectionne.UneSeuleReponse % 2 == 1) {
              if (lettre != 1) newValue[i - 1].A = false;
              if (lettre != 2) newValue[i - 1].B = false;
              if (lettre != 3) newValue[i - 1].C = false;
              if (lettre != 4) newValue[i - 1].D = false;
              if (lettre != 5) newValue[i - 1].E = false;
            }
            // return;
          }

          // calcule du caractère qui a été modifié (dans la solution)
          var v = 0;
          var reponse = ''

          $scope.changement_en_cours = 1

          // alert('AVANT : reponse'+reponse)
          if (newValue[i - 1].A) {
            v += 1;
            $scope.dataCopie[i - 1]['A'] = true
            reponse += 'A';
          }
          else {
            reponse += '_'
          }
          if (newValue[i - 1].B) {
            v += 2;
            $scope.dataCopie[i - 1]['B'] = true
            reponse += 'B';
          } else {
            reponse += '_'
          }
          if (newValue[i - 1].C) {
            v += 4;
            $scope.dataCopie[i - 1]['C'] = true
            reponse += 'C';
          } else {
            reponse += '_'
          }
          if (newValue[i - 1].D) {
            v += 8;
            $scope.dataCopie[i - 1]['D'] = true
            reponse += 'D';
          } else {
            reponse += '_'
          }
          if (newValue[i - 1].E) {
            v += 16;
            $scope.dataCopie[i - 1]['E'] = true;
            reponse += 'E';
          } else {
            reponse += '_'
          }

          $scope.dataCopie[i - 1]['reponse'] = reponse;

          var c = String.fromCharCode(40 + v);
          var caseM = i - 1;
          var chaine, lg;
          if ($rootScope.qcmSelectionne.remord == 1) {
            chaine = $scope.Copie.reponseRemord;
          } else {
            chaine = $scope.Copie.resultat;
          }

          var lg = chaine.length;
          /*        indice=0;
                  while($scope.Copie.id!=$rootScope.qcmSelectionne.listeCopie[indice].id){
                      indice++
                  }
          */
          if (caseM == 0) {
            // if (_DEBUG) console.info('nbq=',lg,'   et
            // $scope.Copie.resultat.length='+$scope.Copie.resultat.length);
            if ($rootScope.qcmSelectionne.remord == 1) {
              $scope.Copie.reponseRemord = c + chaine.substring(1, lg);
            } else {
              $scope.Copie.resultat = c + chaine.substring(1, lg);
            }
          } else if (caseM == lg - 1) {
            // if (_DEBUG) console.info('nbq=',lg,'   et
            // $scope.Copie.resultat.length='+$scope.Copie.resultat.length);
            if ($rootScope.qcmSelectionne.remord == 1) {
              $scope.Copie.reponseRemord = chaine.substring(0, lg - 1) + c;
            } else {
              $scope.Copie.resultat = chaine.substring(0, lg - 1) + c;
            }
          } else if (caseM > 0) {
            // if (_DEBUG) console.info('nbq=',lg,'   et
            // $scope.Copie.resultat.length='+$scope.Copie.resultat.length);
            if ($rootScope.qcmSelectionne.remord == 1) {
              $scope.Copie.reponseRemord = chaine.substring(0, caseM) + c +
                chaine.substring(caseM + 1, lg);
            } else {
              $scope.Copie.resultat = chaine.substring(0, caseM) + c +
                chaine.substring(caseM + 1, lg);
            }
          }
          /*********************** ICI, moulinette reponseRemord -> reponse
           */

          if ($rootScope.qcmSelectionne.remord == 1) {
            // quelle caseM changée ? si pair : reponse n°1, impair :
            // reponse de remord
            //  alert("caseM=" + caseM);
            if (caseM % 2 == 1) {  // la case remord a été changée
              nbQ1 = caseM - 1;
              nbQremord = caseM;
              //    alert("ligne de remord");

            } else {  // la case "réponse n°1" a été changée
              nbQ1 = caseM;
              nbQremord = caseM + 1;
              //    alert("ligne 1");
            }
            //  alert("caseM="+caseM+"  nbQ1="+nbQ1+"  et nbQremord="+nbQremord);

            // maj "Copie.resultat"
            if ($scope.Copie.reponseRemord[nbQremord] ==
              '(') {  // le remord est vide (changé ou pas, on ne sait pas)
              str = $scope.Copie.resultat.split('');
              str[nbQ1 / 2] = $scope.Copie.reponseRemord[nbQremord - 1];
              $scope.Copie.resultat = str.join('');
              // c'est la ligne 1 qui compte
            } else {
              str = $scope.Copie.resultat.split('');
              str[nbQ1 / 2] = $scope.Copie.reponseRemord[nbQremord];
              $scope.Copie.resultat = str.join('');
            }

            // on change le tableau !
            if ($scope.Copie.reponseRemord[nbQremord] == '(') {
              $scope.dataCopie[nbQremord]['point'] = '--';
              $scope.dataCopie[nbQremord]['solution'] = '--';
              $scope.dataCopie[nbQremord]['couleur'] = 'white';

              // alert("tt="+JSON.stringify($rootScope.qcmSelectionne));

              var pc = $scope.calculDesPoint(
                $scope.Copie.reponseRemord.charCodeAt(nbQ1),
                $rootScope.qcmSelectionne.qcmSolution.charCodeAt(nbQ1 / 2),
                nbQ1 / 2);
              $scope.dataCopie[nbQ1]['point'] = pc.point;
              $scope.dataCopie[nbQ1]['solution'] =
                $scope.tabSolution[nbQ1 / 2].reponse;
              $scope.dataCopie[nbQ1]['couleur'] = pc.couleur;

            } else {  // il y a une réponse de remord...
              var pc = $scope.calculDesPoint(
                $scope.Copie.reponseRemord.charCodeAt(nbQremord),
                $rootScope.qcmSelectionne.qcmSolution.charCodeAt(nbQ1 / 2),
                nbQ1 / 2);
              // remord
              $scope.dataCopie[nbQremord]['point'] = pc.point;
              $scope.dataCopie[nbQremord]['solution'] =
                $scope.tabSolution[nbQ1 / 2].reponse;
              $scope.dataCopie[nbQremord]['couleur'] = pc.couleur;
              // reponse non valide
              $scope.dataCopie[nbQ1]['point'] = '-';
              $scope.dataCopie[nbQ1]['solution'] = '--';
              $scope.dataCopie[nbQ1]['couleur'] = '#d6d6c2';
            }
          }
          // et à la fin, passer reponseRemord au GET
          /************************/
          else if ($rootScope.qcmSelectionne.remord == 0) {
            if (_DEBUG) console.info('resultat=', $scope.Copie.resultat);

            if (_DEBUG)
              console.info(
                'nbq=', lg,
                '   et $scope.Copie.resultat.length=' +
                $scope.Copie.resultat.length);
            if (_DEBUG) console.info($scope.dataCopie);

            i = i - 1;
            var iQuestion = i +
              $rootScope.qcmSelectionne
                .PremiereQuestionPageTab[$scope.Copie.page - 1];  // le
            // i=l'indice
            // pour
            // la
            // page
            // (0,
            // 1, 2,
            // 3, 4,
            // 5, 6...)
            if (_DEBUG) console.info('iQuestion=', iQuestion);
            if (iQuestion !== iQuestion) {  // NaN
              iQuestion = i;
            }
            if (_DEBUG) console.info('iQuestion=', iQuestion);

            if (_DEBUG) console.info('i=', i);
            // iQuestion=l'indice pour le qcm (le i=0, pour la page 2, peut
            // correspondre au iQuestion = 6)
            var vide = '_'.repeat(5);
            if ($scope.dataCopie[i]['reponse'] == vide) {
              $scope.dataCopie[i]['point'] =
                $rootScope.qcmSelectionne.ptSiVide[iQuestion];
              $scope.dataCopie[i]['couleur'] = 'white';
            } else {
              if ($scope.dataCopie[i]['reponse'] ==
                $scope.dataCopie[i].solution) {
                $scope.dataCopie[i]['point'] =
                  $rootScope.qcmSelectionne.ptSiJuste[iQuestion];
                $scope.dataCopie[i]['couleur'] = '#60D660';
              } else {
                if ($rootScope.qcmSelectionne.modeCalcul ==
                  0) {  // tout juste - tout faux
                  if (_DEBUG) console.info('mode tt juste-tt faux');

                  $scope.dataCopie[i]['point'] =
                    $rootScope.qcmSelectionne.ptSiFaux[iQuestion];
                  $scope.dataCopie[i]['couleur'] = '#FF4444';

                } else if (
                  $rootScope.qcmSelectionne.UneSeuleReponse ==
                  10) {  // autre mode de calcul...+compliqué
                  if (_DEBUG) console.info('autre mode_10');
                  rep = $scope.Copie.resultat.charCodeAt(i) -
                    40;  //"ABC".charCodeAt(0) // returns 65
                  sol = $rootScope.qcmSelectionne.qcmSolution.charCodeAt(
                    iQuestion) -
                    40;
                  NbRdansSolution = 0;
                  NbJdansReponse = 0;
                  NbFdansReponse = 0;

                  for (b = 1; b < 32; b = b * 2) {
                    if ((sol & b) > 0) NbRdansSolution++;
                    if ((rep & b) > 0) {
                      if ((sol & b) > 0)
                        NbJdansReponse++;
                      else
                        NbFdansReponse++;
                    }
                  }
                  pt = (NbJdansReponse - NbFdansReponse) *
                    $rootScope.qcmSelectionne.ptSiJuste[iQuestion] /
                    NbRdansSolution;
                  if (pt <= $rootScope.qcmSelectionne.ptSiFaux[iQuestion]) {
                    pt = $rootScope.qcmSelectionne.ptSiFaux[iQuestion];
                    $scope.dataCopie[i]['couleur'] = '#FF4444';
                  } else {
                    $scope.dataCopie[i]['couleur'] = '#ffa544'
                  }
                  $scope.dataCopie[i]['point'] = pt;

                } else if (
                  $rootScope.qcmSelectionne.UneSeuleReponse ==
                  20) {  // autre mode de calcul...+compliqué
                  if (_DEBUG) console.info('autre mode_20');

                  rep = $scope.Copie.resultat.charCodeAt(i) -
                    40;  //"ABC".charCodeAt(0) // returns 65
                  sol = $rootScope.qcmSelectionne.qcmSolution.charCodeAt(
                    iQuestion) -
                    40;

                  NbRdansSolution = 0;
                  NbJdansReponse = 0;
                  NbFdansReponse = 0;

                  for (b = 1; b < 17; b = b * 2) {
                    if ((sol & b) == (rep & b))
                      NbJdansReponse++;
                    else
                      NbFdansReponse++;
                  }

                  pt = NbJdansReponse *
                    $rootScope.qcmSelectionne.ptSiJuste[iQuestion] /
                    $rootScope.qcmSelectionne.nbReponse;
                  if (_DEBUG)
                    console.info(
                      '---> pt=' + pt + ' et ' + NbJdansReponse + ' et ' +
                      $rootScope.qcmSelectionne.ptSiJuste[iQuestion] +
                      ' et ' + $rootScope.qcmSelectionne.nbReponse);
                  if (pt <= $rootScope.qcmSelectionne.ptSiFaux[iQuestion]) {
                    // pt = $rootScope.qcmSelectionne.ptSiFaux[i];
                    $scope.dataCopie[i]['couleur'] = '#FF4444';
                  } else {
                    $scope.dataCopie[i]['couleur'] = '#ffa544';
                  }
                  $scope.dataCopie[i]['point'] = pt;

                } else if (
                  $rootScope.qcmSelectionne.UneSeuleReponse ==
                  30) {  // autre mode de calcul...+diploma
                  if (_DEBUG) console.info('autre mode_30');

                  var rep = $scope.Copie.resultat.charCodeAt(i) -
                    40;  //"ABC".charCodeAt(0) // returns 65
                  var sol =
                    $rootScope.qcmSelectionne.qcmSolution.charCodeAt(i) - 40;

                  var NbRfausse = 0;
                  var NbRjuste = 0;
                  var NbRdansSolution = 0;

                  var pt = 0;

                  for (var b = 1; b < 17; b = b * 2) {
                    if ((sol & b) > 0) NbRdansSolution++;

                    if (sol & b) {  // case à cocher
                      if (rep & b)
                        NbRjuste++;
                      else
                        NbRfausse++;

                    } else {  // case à na pas cocher
                      if (rep & b)
                        NbRfausse++;
                      else
                        NbRjuste++;
                    }
                  }

                  if (_DEBUG) console.info('-----i=' + i);
                  if (_DEBUG) console.info('-----NbRjuste=' + NbRjuste);
                  if (_DEBUG) console.info('-----NbRfausse=' + NbRfausse);
                  if (_DEBUG)
                    console.info(
                      '-----NbRdansSolution=' + NbRdansSolution);

                  if (NbRdansSolution == 1) {
                    if (NbRfausse >= 1) {
                      pt = 0;  //$rootScope.qcmSelectionne.ptSiFaux[i];
                    }          /*else{
                                  pt = 1;//$rootScope.qcmSelectionne.ptSiJuste[i];
                              }*/
                    if (_DEBUG) console.info('-----pt=' + pt);
                  }

                  if (NbRdansSolution > 1) {
                    if (NbRfausse == 0) {
                      if (_DEBUG) console.info('-----0=' + pt);
                      pt = $rootScope.qcmSelectionne.ptSiJuste[i];
                    } else if (NbRfausse == 1) {
                      if (_DEBUG) console.info('-----1=' + pt);
                      pt = $rootScope.qcmSelectionne.ptSiJuste[i] / 2;
                    } else if (NbRfausse == 2) {
                      if (_DEBUG) console.info('-----2=' + pt);
                      pt = $rootScope.qcmSelectionne.ptSiFaux[i];
                    } else {
                      pt = $rootScope.qcmSelectionne.ptSiVide[i];
                    }
                    if (_DEBUG) console.info('-----pt=' + pt);
                  }

                  if (_DEBUG) console.info('-----pt=' + pt);

                  if (pt <= $rootScope.qcmSelectionne.ptSiFaux[i]) {
                    // pt = $rootScope.qcmSelectionne.ptSiFaux[i];
                    $scope.dataCopie[i]['couleur'] = '#FF4444';
                  } else {
                    $scope.dataCopie[i]['couleur'] = '#ffa544';
                  }
                  $scope.dataCopie[i]['point'] = pt;
                }
              }
            }
          }  // fin (remord==0)
          //console.log('milieu1 cop.js');

          await services.remordUpdateCopie($rootScope.qcmSelectionne.id, $scope.Copie);

          //console.log('milieu2 cop.js');


          ServiceQcm.initListeEtudiant($rootScope.qcmSelectionne);
          //console.log('milieu3 cop.js');

          ServiceQcm.calculNotes($rootScope.qcmSelectionne);
          //      });
          // on PEUT FAIRE MIEUX ...
          // dans $rootScope : modifier listeCopie et listeEtudiant
          //$scope.majListeCopie();
          //console.log('milieu4 cop.js');

          // affichage
          $scope.NbJdansReponse = 0;
          $scope.NbFdansReponse = 0;
          $scope.NbVdansReponse = 0;
          if ($rootScope.qcmSelectionne.remord == 1) {  //remors
            var nb = $rootScope.qcmSelectionne.qcmSolution.length;
            //alert("remord ! calcul, nb=" + nb);
            for (i = 0; i < nb; i++) {
              //console.log("*" + i + ", " + $scope.Copie.resultat[i]);
              if ($scope.Copie.resultat[i] == '(') {
                $scope.NbVdansReponse++;
              } else {
                if ($scope.Copie.resultat[i] == $rootScope.qcmSelectionne.qcmSolution[i]) {
                  $scope.NbJdansReponse++;
                } else {
                  $scope.NbFdansReponse++;
                }
              }
            };
            a = 1;
          } else {
            var vide = '_'.repeat(5);
            for (i = 0; i < $scope.tabSolution.length; i++) { // pas de remord...
              if ($scope.dataCopie[i]["reponse"] == vide) {
                $scope.NbVdansReponse++;
              } else {
                if ($scope.dataCopie[i]["reponse"] == $scope.dataCopie[i].solution) {
                  $scope.NbJdansReponse++;
                } else {
                  $scope.NbFdansReponse++;
                }
              }
            };
          }
          //updatesolcopie


          $scope.changement_en_cours = 0;
          console.log('fin cop.js');


        }

      }, true
    );


  });
